import { useEffect, useState } from "react";
import { api } from "../api/client";

export interface CustomPaymentMethod {
  id: string;
  code: string;
  name: string;
  icon: string;
  color: string | null;
  eet_enabled: boolean;
  is_active: boolean;
  sort_order: number;
}

/** Tenant-defined payment methods — provider slug on "other" payments. */
export function useCustomPaymentMethods(): CustomPaymentMethod[] {
  const [methods, setMethods] = useState<CustomPaymentMethod[]>([]);
  useEffect(() => {
    api.get<CustomPaymentMethod[]>("/tenant/payment-methods")
      .then((r) => setMethods(r.data))
      .catch(() => {});
  }, []);
  return methods;
}

/** Friendly name for a custom provider code; falls back to the raw slug. */
export function customPaymentName(methods: CustomPaymentMethod[], code: string): string {
  return methods.find((m) => m.code === code)?.name ?? code;
}
